import type MP4Box from 'mp4box';
import { TrackEventProp } from '@studio/constants/tracking-constants';
import type { VideoUploadTrackEventProperties } from '../../types/upload-video';

// Our sample duration is found by taking sample_durations divided by nb_samples.
const logSampleDuration = (info: MP4Box.Mp4BoxInfo, trackEventProperties: VideoUploadTrackEventProperties): void => {
  if (info.videoTracks.length) {
    const [videoTrack] = info.videoTracks;
    const { nb_samples: sampleCount, samples_duration: totalSampleDuration } = videoTrack;
    const sampleDuration = totalSampleDuration / sampleCount;
    console.log(`Sample duration: ${sampleDuration}`);

    trackEventProperties[TrackEventProp.VIDEO_UPLOAD_SAMPLE_DURATION] = sampleDuration;
  }
};

export default logSampleDuration;
